import axios from "../../util/axios";

// 系统公告API
export default {
  /** 创建公告 */
  create: (data) => axios.post({url: "/basedata/common/notice/create", data}),
  
  /** 更新公告 */
  update: (data) => axios.post({url: "/basedata/common/notice/update", data}),
  
  /** 删除公告 */
  delete: (id) => axios.get({url: `/basedata/common/notice/delete/${id}`}),
  
  /** 获取公告详情 */
  getDetail: (id) => axios.get({url: `/basedata/common/notice/detail/${id}`}),
  
  /** 分页查询公告列表 */
  list: (params) => axios.get({url: "/basedata/common/notice/list", data: params}),
  
  /** 发布公告 */
  publish: (id) => axios.post({url: `/basedata/common/notice/publish/${id}`}),
  
  /** 撤回公告 */
  withdraw: (id) => axios.post({url: `/basedata/common/notice/withdraw/${id}`}),
  
  /** 设置置顶 */
  setTop: (id, isTop) => axios.post({url: `/basedata/common/notice/setTop?id=${id}&isTop=${isTop}`}),
  
  /** 记录用户阅读 */
  recordRead: (noticeId, userId, deviceType) => axios.get({url: "/basedata/common/notice/recordRead", data: {noticeId, userId, deviceType}}),
  
  /** 获取公告阅读记录 */
  getReadLogs: (noticeId) => axios.get({url: `/basedata/common/notice/readLogs/${noticeId}`}),
  
  /** 获取所有公告分类 */
  getAllCategories: () => axios.get({url: "/basedata/common/notice/categories"}),
  
  /** 获取当前用户有权限阅读的公告列表（用于首页滚动显示） */
  getMyNotices: (pageSize = 10) => axios.get({url: "/basedata/common/notice/myNotices", data: {pageSize}}),
}

